import {
  Component,
  OnInit,
  ViewChildren,
  ViewChild,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Department } from "../Models/Department";
import { Ward } from "../Models/Ward";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { PhBhpObserveObservationComponent } from "../ph-bhp-observe-observation/ph-bhp-observe-observation.component";
import { PHBHPFeaturePackageObserveObservationService } from "../ph-bhp-feature-package-observe-observation.service";
import { forkJoin, Observable, Subscription } from "rxjs";
import { AppConfig } from "src/app/app.config";
import { TranslationKeys } from "ph-bhp-localization";
import { filter } from "rxjs/operators";
import { ProfessionalSubCategory } from "src/app/models/professional-sub-category";
import { CatalogMasterService } from "../../services/catalog-master.service";
import { ProfessionalCategory } from "src/app/models/professional-category";
import { Country } from "../../../../../../../Mobile/Observe/src/app/models/Country";
import { ProfessionalSubCategoryDTO } from "src/app/models/professional-sub-category-dto";
import { GeneralSettings } from "src/app/configure/Models/GeneralSettings";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "lib-ph-bhp-new-observe-observation",
  templateUrl: "./ph-bhp-new-observe-observation.component.html",
  styleUrls: ["./ph-bhp-new-observe-observation.component.css"],
})
export class PhBhpNewObserveObservationComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  userData;
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild("asepticModal") asepticModal: TemplateRef<any>;
  @ViewChild("cancelmodal") cancelmodal: TemplateRef<any>;
  @ViewChild("congratulationmodal") congratulationmodal: TemplateRef<any>;
  @ViewChild("almostmodal") almostmodal: TemplateRef<any>;
  emitData: any = {
    key: "",
    val: "",
  };
  department: Array<Department> = [];
  allProfessionalCategories: Array<ProfessionalCategory> = [];
  allSubCategories: Array<ProfessionalSubCategoryDTO> = [];
  wardtrigger: boolean = true;
  depttrigger: boolean = true;
  institutionID;
  showActive: boolean = false;
  wards: Array<Ward> = [];
  formdata: UntypedFormGroup;
  professionalformdata: UntypedFormGroup;
  wardID: number;
  departmentID: number;
  wardWarningMessage: boolean = false;
  connectionWarningMessage: boolean = false;
  showMessageLaptop: boolean = false;
  showMessageApple: boolean = false;
  showMessageAndroid: boolean = false;
  connectionMessage: string = "";
  handWashingEnabled: boolean;
  showProfessionalSubcategory: boolean;
  showAseptictasks: boolean;
  iswebKessConnectionEstablished: boolean;
  enableHandKissSurveillance: boolean;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private modalService: BsModalService,
    private layoutService: PHBHPLayoutPackageService,
    private service: PHBHPFeaturePackageObserveObservationService,
    public appConfig: AppConfig,
    private catalogMasterService: CatalogMasterService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID;
      this.userData = this.appConfig.userData;
      this.getWardsandDepartmentsAndCategoriesbyInstitutionId();
    }

    this.formdata = new UntypedFormGroup({
      // TODO this is now readonly, so could remove form altogether
      department: new UntypedFormControl(
        "",
        Validators.compose([Validators.required])
      ),
      ward: new UntypedFormControl("", Validators.compose([Validators.required])),
      category: new UntypedFormControl("", Validators.compose([Validators.required])),
      subCategory: new UntypedFormControl(""),
      wardName: new UntypedFormControl(""),
    });

    this.subscription = this.layoutService.institutionIDSubject
      .asObservable()
      .subscribe((res) => {
        this.userData = this.appConfig.userData;
        this.institutionID = this.layoutService.institutionID;
        this.getWardsandDepartmentsAndCategoriesbyInstitutionId();
      });

    this.connectionWarningMessage = true;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      this.showMessageLaptop = true;
      this.showMessageApple = true;
      this.showMessageAndroid = true;
    } else {
      var isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      this.showMessageApple = isApple;
      this.showMessageAndroid = !isApple;
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onWardIDChange(event: Ward) {
    this.wardtrigger = true;
    this.wardID = event.wardID;

    this.formdata.patchValue({
      ward: event,
      wardName: event.wardName,
    });

    if (this.wardtrigger) {
      this.depttrigger = false;
      if (this.wardID) {
        //this.wardWarningMessage = false;
        var dep = this.department.find(
          (res) => res.departmentID == event.departmentID
        );
        this.formdata.patchValue({ department: dep || {} });
        this.depttrigger = true;
      } else {
        //this.wardWarningMessage = true;
      }
    }
  }


  getWardsandDepartmentsAndCategoriesbyInstitutionId() {
    this.layoutService.showLoader = true;
    const userId = this.appConfig.userData.userId;

    const configDetails: Observable<GeneralSettings> = this.service.getConfigDetails(
      this.layoutService.institutionID
    );
    const departaments: Observable<any> = this.service.GetWardsAndDepartments(
      this.layoutService.institutionID
    );
    const professionaLCategories: Observable<ProfessionalCategory[]> =
      this.catalogMasterService.getProfessionalCategories();
    const professionalSubCategories: Observable<ProfessionalSubCategoryDTO[]> =
      this.catalogMasterService.getProfessionalSubCategoriesByCountry(
        this.layoutService.institutionCountryId
      );

    forkJoin([
      configDetails,
      departaments,
      professionaLCategories,
      professionalSubCategories,
    ]).subscribe(
      ([
        configDetails,
        departamentsAndWardsRes,
        professionaLCategoriesRes,
        professionalSubCategoriesRes,
      ]) => {
        this.handWashingEnabled = configDetails.enableHandWashing;
        this.showProfessionalSubcategory =
          configDetails.enableProfessionalSubCategory;
        this.showAseptictasks = configDetails.enableAsepticSubTask;
        this.iswebKessConnectionEstablished = configDetails.iswebKessConnectionEstablished;
        this.enableHandKissSurveillance = configDetails.enableHandKissSurveillance;

        if (departamentsAndWardsRes == null) {
          this.layoutService.showLoader = false;
          this.wardWarningMessage = true;
          return;
        }
        if (departamentsAndWardsRes && departamentsAndWardsRes["wardsDetails"]) {
          this.wards = departamentsAndWardsRes["wardsDetails"];
          this.wards = this.wards.filter(ward => ward.departmentID && ward.isActive && !ward.isDeleted);
        }
        if (departamentsAndWardsRes && departamentsAndWardsRes["departments"])
          this.department = departamentsAndWardsRes["departments"];
        if (this.wards.length === 0) {
          this.wardWarningMessage = true;
        } else {
          this.wardWarningMessage = false;
          this.formdata.patchValue({
            department: this.department.find((res) => res.departmentID == this.wards[0].departmentID),
            ward: this.wards[0],
            wardName: this.wards[0].wardName,
          });
        }

        this.allProfessionalCategories = professionaLCategoriesRes;
        this.formdata.patchValue({
          category: this.allProfessionalCategories[0],
          categoryName: this.allProfessionalCategories[0].categoryName,
        });

        if (this.showProfessionalSubcategory) {
          this.allSubCategories = professionalSubCategoriesRes.filter(this.filterVisibility);
        }

        this.layoutService.showLoader = false;
      },
      (err) => {
        this.layoutService.showLoader = false;
      }
    );
  }


  openSopDetails(temp, value, checkFormValid?) {
    if (checkFormValid && this.formdata.invalid) {
      return true;
    }


    this.userData = this.appConfig.userData;
    var currentDate = new Date().toISOString();
    var sessionName = value.sessionName ? value.sessionName : `W${this.userData.userId}-${new Date().getTime()}`;
    var initialState = {
      currentDate: currentDate,
      selectedward: value.ward.wardName,
      selecteddept: value.department.departmentName,
      institutionID: this.layoutService.institutionID,
      wardID: value.ward.wardID,
      departmentID: value.department.departmentID,
      departmentTypeID: value.ward.departmentTypeID,
      departmentTypeName: value.ward.departmentTypeName,
      sessionName: sessionName,
      createdBy: this.userData.userId,
      categories: this.allProfessionalCategories,
      subcategories: this.allSubCategories,
      handWashingEnabled: this.handWashingEnabled,
      iswebKessConnectionEstablished: this.iswebKessConnectionEstablished,
      enableHandKissSurveillance: this.enableHandKissSurveillance,
      showProfessionalSubcategory: this.showProfessionalSubcategory,
      showAseptictasks: this.showAseptictasks,
      observeCount: value.observeCount || 0,
      totalCount: value.totalCount || 0,
      existingSession: value.existingSession || false,
      categorylist: value.categorylist || [],
      observationSessionID: value.observationSessionID || 0,
      activecategory: value.activecategory || {},
      startminutes: value.startminutes || 0,
      observationSessionValue: null
    };

    var newObservationSession = {
      observationSessionID: 0,
      institutionID: this.layoutService.institutionID,
      wardID: initialState.wardID,
      departmentID: initialState.departmentID,
      departmentTypeID: initialState.departmentTypeID,
      sessionName: initialState.sessionName,
      startDateTime: initialState.currentDate,
      endDateTime: null,
      deleted: 0,
      deletedBy: 0,
      deletedDateTime: null,
      migrated: 0,
      migratedBy: 0,
      migratedDateTime: "2019-07",
      exportedToCleanHandCampaign: 0,
      exportedToCleanHandCampaignBy: 0,
      exportedToCleanHandCampaignDateTime: "2019-07",
      createdBy: initialState.createdBy,
    }

    this.layoutService.showLoader = true;
    this.service.createObserveSession(newObservationSession).subscribe((res: any) => {
      initialState.observationSessionValue = res;
      this.layoutService.showLoader = false;
      this.modalService.show(PhBhpObserveObservationComponent, {
        initialState,
        class: "modal-full w-full remove-padding",
      });
    });
  }


  filterVisibility = (subCategory: ProfessionalSubCategoryDTO) => {
    switch (this.userData.roleName.roleId) {
      case 2:
        if (!ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory)) {
          return false;
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType != 'all') {
          // show same country subcategory for CA, no matter visibilityType
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.appConfig.userData.country);
        }
        return true; // all global subcategories

      case 3:
      case 4:
      case 5:
        if (!subCategory.professionalSubCategoryCountryConfiguration) {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA && subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.length > 0) {
          let enability = subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.find(e => e.institutionId == this.layoutService.institutionID);
          return enability ? enability.isEnabledForNewObservations : ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory);
        } else if (!ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory)) {
          return false;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.visibilityType === 'all') {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'institutions') {
          return subCategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility.some(v => v.institutionId == this.layoutService.institutionID);
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'country') {
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.appConfig.userData.country);
        }
        return false;
    }
  }

  onClickWardHandler(event: Event) {
    this.layoutService.showLoader = true;
    this.service.GetWardsAndDepartments(this.layoutService.institutionID).subscribe((departamentsAndWardsRes) => {
      if (departamentsAndWardsRes == null) {
        this.wardWarningMessage = true;
        return;
      }

      if (departamentsAndWardsRes && departamentsAndWardsRes["wardsDetails"]) {
        this.wards = departamentsAndWardsRes["wardsDetails"];
        this.wards = this.wards.filter(ward => ward.departmentID && ward.isActive && !ward.isDeleted);
      }

      if (departamentsAndWardsRes && departamentsAndWardsRes["departments"]) {
        this.department = departamentsAndWardsRes["departments"];
      }

      this.wardWarningMessage = this.wards.length === 0;
      if (!this.wardWarningMessage && !this.wards.find((ward) => ward.wardID == this.formdata.get('ward').value.wardID)) {
        this.formdata.patchValue({
          department: this.department.find((res) => res.departmentID == this.wards[0].departmentID),
          ward: this.wards[0],
          wardName: this.wards[0].wardName,
        });
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false });
  }

  getDepartmentTypeName(ward: any) {
    return ward.departmentTypeID === 1 ? '' : `(${ this.layoutService.translateText(ward.departmentTypeName) })`;
  }

}